import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  duration?: number;
  /** Adds a slight backward tilt that settles flat — depth without spectacle. */
  depth?: boolean;
}

/**
 * Viewport-triggered reveal. Fires once, respects prefers-reduced-motion.
 * The element rises, fades, and rotates a few degrees on the X axis inside a
 * perspective container, so content reads as entering from behind the page plane.
 */
export function Reveal({
  children,
  className,
  delay = 0,
  duration = 0.6,
  depth = true
}: RevealProps) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className} data-id="element-410" data-mp="2xpy30o32mxno">{children}</div>;
  return <div className={className} style={{
    perspective: 1200
  }} data-id="element-411" data-mp="2xrixyetasim2">
      <motion.div initial={{
      opacity: 0,
      y: 18,
      rotateX: depth ? 7 : 0
    }} whileInView={{
      opacity: 1,
      y: 0,
      rotateX: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration,
      delay,
      ease: [0.22, 1, 0.36, 1]
    }} style={{
      transformOrigin: 'center top',
      transformStyle: 'preserve-3d'
    }} data-id="element-412" data-mp="81p3edzig647">
        {children}
      </motion.div>
    </div>;
}